import UploadButton from '@components/UploadButton/UploadButton';
import { Typography } from '@mui/material';
import React from 'react';

interface IUserUploadButtonProps {
	onUsersUpload: (file: any) => any;
	loading: boolean;
}

const UserUploadButton: React.FC<IUserUploadButtonProps> = ({
	onUsersUpload,
	loading
}) => (
	<Typography
		sx={{
			mr: 2,
			display: {
				xs: 'none',
				sm: 'block'
			}
		}}
		component="span"
	>
		<UploadButton
			variant="outlined"
			size="small"
			inputName="upload-users"
			text={intl.tr('users.upload.button')}
			onFileUpload={onUsersUpload}
			loading={loading}
			accept="application/json"
		/>
	</Typography>
);

export default UserUploadButton;
